// El texto de un error de la ficha: la razón y el texto los decide errores.ts (puro, probado con Deno); aquí sólo se le da el catálogo
// compartido con Argus Team (app/shared/rotulos/errores.ts: textos 46 a 52 y los generales, «unauthorized» para la sesión vencida).
// Nunca el mensaje crudo de la base.
import { MENSAJES_FICHA } from "./catalogo.ts";
import { mensajeDeRazon, type RazonFicha } from "./errores.ts";

export { accionDeError, razonDe } from "./errores.ts";

/** El texto para la persona. */
export function mensajeDeError(razon: RazonFicha): string {
  return mensajeDeRazon(razon, (codigo) => MENSAJES_FICHA[codigo as RazonFicha]);
}

/** ¿La lectura se canceló desde la pantalla? (no es un error que mostrar) */
export const esCancelacion = (e: unknown): boolean => e instanceof DOMException && e.name === "AbortError";
